import { token } from '@atlaskit/tokens';

type IconProps = {
	width?: string | number;
	height?: string | number;
};

export const CodeReviewerIcon = ({ width = '23', height = '26' }: IconProps) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 23 26"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12.1228 1.0696C11.7372 0.847967 11.2628 0.847967 10.8772 1.0696L1.37716 6.52919C0.989192 6.75215 0.75 7.16549 0.75 7.61297V18.5242C0.75 18.9716 0.989191 19.385 1.37716 19.608L10.8772 25.0675C11.2628 25.2892 11.7372 25.2892 12.1228 25.0675L21.6228 19.608C22.0108 19.385 22.25 18.9716 22.25 18.5242V7.61297C22.25 7.16549 22.0108 6.75215 21.6228 6.52919L12.1228 1.0696Z"
				fill="#82B536"
				stroke={token('color.border')}
				strokeWidth="0.5"
			/>
			<mask id="mask0_1374_6858" maskUnits="userSpaceOnUse" x="1" y="1" width="21" height="24">
				<path
					d="M10.5035 1.57271C11.1205 1.2181 11.8795 1.2181 12.4965 1.57271L20.9965 6.45761C21.6173 6.81435 22 7.47569 22 8.19165V17.9455C22 18.6615 21.6173 19.3228 20.9965 19.6795L12.4965 24.5644C11.8795 24.919 11.1205 24.919 10.5035 24.5644L2.00346 19.6795C1.38271 19.3228 1 18.6615 1 17.9455V8.19165C1 7.47569 1.38271 6.81435 2.00346 6.45761L10.5035 1.57271Z"
					fill="#FFA900"
				/>
			</mask>
			<g mask="url(#mask0_1374_6858)">
				<path
					d="M10.6751 7.0413C10.6302 6.18122 10.4491 5.03372 10.4202 4.62024C10.6527 5.11706 10.5616 3.82854 10.5113 3.61699C10.4898 3.83388 10.3934 3.66615 10.4138 3.5187C10.7587 3.72598 10.5241 0.210855 10.2221 2.01863C10.1439 2.87123 9.99603 4.73885 9.97461 6.09681C10.1546 6.76031 10.4909 9.54782 10.6751 7.04237V7.0413Z"
					fill="#B3DF72"
				/>
				<path
					d="M7.29441 8.51073C7.07804 8.10259 6.8456 7.74893 6.39464 7.31622C6.43213 7.67414 6.2404 7.42842 6.22326 7.2596C6.54461 7.32691 6.11292 6.86214 5.96082 6.79804C6.00474 6.86321 5.92654 6.92197 5.8537 6.82261C6.1247 6.80124 5.15853 5.6623 5.a06641 6.17408C5.19066 6.35358 5.05569 6.43477 5.27849 6.35678C5.03534 6.56405 5.42632 6.56085 5.44238 6.5961C5.29242 6.82475 5.75194 6.86001 5.55913 6.91984C5.63304 7.35576 7.33512 9.4659 7.29441 8.5118V8.51073Z"
					fill="#B3DF72"
				/>
				<path
					d="M5.6735 12.3385C5.17755 11.9432 4.62912 11.6793 3.83968 11.5404C4.16853 11.8438 3.78612 11.7199 3.61902 11.5949C4.35812 11.3246 0.316648 11.128 1.85054 11.7445C1.9191 11.4047 1.87197 11.846 2.0787 11.721C2.23723 11.6099 2.38826 11.6462 2.38505 11.7338C2.38398 11.831 2.80922 11.5735 2.69354 11.7573C3.04809 11.8107 6.48972 13.158 5.6735 12.3385Z"
					fill="#B3DF72"
				/>
				<path
					d="M5.16804 15.8193C4.59604 16.0052 4.06797 16.299 3.55703 16.8653C3.98014 16.7531 3.66842 17.0117 3.48311 17.0694C3.66949 16.2852 1.35688 19.4648 2.67654 18.5663C2.41411 18.3248 2.7858 18.6015 2.7783 18.3718C2.88434 17.8814 3.38458 17.9145 3.78733 17.344C4.01549 16.969 6.0828 15.9337 5.16804 15.8204V15.8193Z"
					fill="#B3DF72"
				/>
				<path
					d="M9.15363 19.6561C8.60627 16.4231 8.4306 19.0621 8.53129 20.56C8.73695 20.107 8.71874 20.5878 8.62662 20.7865C8.42631 20.2887 8.39525 21.8069 8.60841 21.4703C8.61055 21.5269 8.62876 21.5846 8.62769 21.6381C8.32991 21.4425 8.51201 24.2172 8.91262 22.8016C8.58806 22.7097 9.11935 22.7738 8.79693 22.2952C9.16755 21.825 8.88263 20.4019 9.15363 19.6572V19.6561Z"
					fill="#B3DF72"
				/>
				<path
					d="M14.936 22.1817C15.5059 21.4872 14.0138 16.9838 14.1916 19.4465C14.258 19.7681 14.3437 20.4839 14.4711 20.9936C14.619 20.5363 14.665 20.9968 14.589 21.1987C14.3544 20.75 14.4347 22.1806 14.6179 21.8558C14.6168 22.0577 14.4615 22.2565 14.5065 22.9146C14.4401 23.7458 14.8621 23.5696 14.8643 23.1358C14.6275 23.0834 15.1031 23.0834 14.8128 22.6539C15.0549 22.6454 14.7711 22.0748 14.935 22.1817H14.936Z"
					fill="#B3DF72"
				/>
				<path
					d="M20.1874 17.0919C19.6314 16.907 19.0883 16.7948 18.3439 16.7852C18.6974 17.0267 18.3043 16.9711 18.1457 16.86C18.4874 16.6837 17.683 16.6463 17.5148 16.6923C17.6262 16.7179 17.5694 16.8098 17.4409 16.782C17.7141 16.6121 15.8877 16.3386 16.1952 16.7265C16.1684 16.8194 16.374 16.8002 16.4405 16.9188C16.4779 16.9188 16.479 16.72 16.5272 16.7874C16.4683 17.1015 16.8357 16.8589 16.8775 16.875C16.7522 17.1656 21.1407 17.8804 20.1884 17.094L20.1874 17.0919Z"
					fill="#B3DF72"
				/>
				<path
					d="M20.7892 11.8666C20.1872 11.8142 19.6569 11.8185 18.8868 11.8879C19.3302 12.0941 18.7465 12.1187 18.694 11.9413C19.0528 11.8452 18.1198 11.8056 18.0256 11.8986C18.1455 11.9114 18.0931 12.0097 17.9602 11.9958C18.0598 11.7458 15.7001 11.7544 16.9501 12.2544C16.9887 12.248 16.9619 12.0535 17.0208 12.1123C17.0037 12.4317 17.3454 12.1422 17.3915 12.154C17.4279 12.4018 17.9217 12.1112 17.806 12.2822C18.0545 12.576 21.9385 12.389 20.7881 11.8666H20.7892Z"
					fill="#B3DF72"
				/>
				<path
					d="M16.3381 5.39052C16.2942 4.82319 16.8726 4.42787 16.9808 3.8584C16.7516 2.94062 14.9317 6.4707 15.5283 5.80828C15.7072 5.5978 13.6034 8.74217 14.3554 8.74431C14.3822 8.802 14.6425 8.44516 14.5932 8.41952C14.545 8.3725 14.4721 8.36181 14.5225 8.31801C14.8128 8.45049 14.7014 7.93338 14.7367 7.88102C15.2905 7.5199 15.6493 6.04975 16.3392 5.38839L16.3381 5.39052Z"
					fill="#B3DF72"
				/>
			</g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.2236 10.458C12.0449 10.458 10.3343 12.1511 9.68457 12.9955C10.1177 13.8421 12.0449 15.533 14.2236 15.533C16.4024 15.533 18.3296 13.8399 18.7627 12.9955C18.1152 12.1489 16.4024 10.458 14.2236 10.458ZM14.2236 11.158C15.2386 11.158 16.0611 11.9805 16.0611 12.9955C16.0611 14.0105 15.2386 14.833 14.2236 14.833C13.2086 14.833 12.3861 14.0105 12.3861 12.9955C12.3861 11.9805 13.2086 11.158 14.2236 11.158Z"
				fill="#101214"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.0965 13.0002L15.4112 14.5993L14.2562 16.603L12.2109 16.2618L11.4868 18.2021H9.17461L8.44617 16.2618L6.40086 16.603L5.24805 14.5993L6.56055 13.0002L5.24805 11.4012L6.40086 9.3974L8.44617 9.73647L9.17461 7.79834H11.4868L12.2109 9.73647L14.2562 9.3974L15.4134 11.4012L14.0965 13.0002Z"
				fill="white"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.2234 14.8352C13.2084 14.8352 12.3859 14.0105 12.3859 12.9955C12.3859 11.9805 13.2084 11.158 14.2234 11.158C14.6325 11.158 15.0109 11.2914 15.3171 11.5189L15.4134 11.4008L14.9015 10.5127C14.6828 10.4777 14.4553 10.458 14.2234 10.458C12.0446 10.458 10.334 12.1489 9.68652 12.9955C10.1175 13.8421 12.0446 15.533 14.2234 15.533C14.4531 15.533 14.6806 15.5133 14.9037 15.4783L15.4112 14.5989L15.3128 14.4786C15.0065 14.7018 14.6303 14.8352 14.2234 14.8352Z"
				fill="#82B536"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.0964 13.0001L15.3126 14.4788C15.0064 14.702 14.6301 14.8354 14.2232 14.8354C13.2082 14.8354 12.3857 14.0107 12.3857 12.9957C12.3857 11.9807 13.2082 11.1582 14.2232 11.1582C14.6323 11.1582 15.0107 11.2916 15.317 11.5191L14.0964 13.0001Z"
				fill="#101214"
			/>
		</svg>
	);
};
